import React, { FunctionComponent } from 'react';
import { Form, Card, Input, DatePicker } from 'antd';
import styles from '../index.module.less';


interface ProfileProps {
  className: string;
  editable: boolean;
}

const rules = [{ required: true, message: '必填' }];

export const Profile: FunctionComponent<ProfileProps> = ({ editable, className }) => {
  return (
    <Card bordered={false} title="基本资料" size="small" className={className}>
      <Form.Item
        label="桩企名称"
        colon={false}
        name="companyName"
        required
        rules={rules}
      >
        <Input readOnly={!editable} placeholder="填写时请与营业执照上的企业注册名称相同" />
      </Form.Item>
      <Form.Item
        label="桩企简称"
        colon={false}
        name="company_name_short"
        required
        rules={rules}
      >
        <Input readOnly={!editable} placeholder="填写桩企简称" />
      </Form.Item>
      <Form.Item
        label="企业ID"
        colon={false}
        name="companyId"
        required
        rules={rules}
      >
        <Input readOnly={!editable} placeholder="请填写营业执照上的18位编码" />
      </Form.Item>
      <Form.Item
        label="联络人"
        colon={false}
        name="linkman"
        required
        rules={rules}
      >
        <Input readOnly={!editable} />
      </Form.Item>
      <Form.Item
        label="联络方式"
        colon={false}
        name="linkPhoneNum"
        required
        rules={rules}
      >
        <Input readOnly />
      </Form.Item>
      <Form.Item
        label="所在地区"
        colon={false}
        name="area"
        required
        rules={rules}
      >
        <Input readOnly={!editable} />
      </Form.Item>
      <Form.Item
        label="公司注册时间"
        colon={false}
        name="registerTime"
        required
        rules={rules}
      >
        <DatePicker
          placeholder="请选择注册时间"
          style={{ width: '100%' }}
          disabled={!editable}
        />
      </Form.Item>
      <Form.Item
        label="对接业务邮箱"
        colon={false}
        name="businessEmail"
        rules={[{ type: 'email', message: '请输入有效邮箱' }, rules[0]]}
        required
      >
        <Input readOnly={!editable} />
      </Form.Item>
    </Card>
  );
}